import React, { lazy, Suspense } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { connect } from 'react-redux'
import { withAuthenticationRequired } from '@auth0/auth0-react'

import DataLayer from './data'
import Layout from 'layouts'

const routes = [
  // Apps pages
  // {
  //   path: '/apps/main',
  //   Component: lazy(() => import('pages/apps/main')),
  //   exact: true,
  //   restricted: true,
  // },
  // {
  //   path: '/apps/second',
  //   Component: lazy(() => import('pages/apps/second')),
  //   exact: true,
  //   restricted: true,
  // },
  // Home pages
  {
    path: '/',
    Component: lazy(() => import('pages/home')),
    exact: true,
    restricted: true,
  },
  {
    path: '/home',
    Component: lazy(() => import('pages/home')),
    exact: true,
    restricted: true,
  },
  {
    path: '/articles',
    Component: lazy(() => import('pages/home')),
    exact: true,
    restricted: true,
  },
  {
    path: '/articles/recently-translated',
    Component: lazy(() => import('pages/home')),
    exact: true,
    restricted: true,
  },
  {
    path: '/articles/under-review',
    Component: lazy(() => import('pages/home')),
    exact: true,
    restricted: true,
  },
  {
    path: `/tasks/:list_id?/:task_id?`,
    Component: lazy(() => import('./components/swifteq/HcManager/ArticlesManager')),
    exact: true,
    restricted: true,
  },
  {
    path: '/articles/:id/edit',
    Component: lazy(() => import('pages/home')),
    exact: true,
    restricted: true,
  },
  {
    path: '/articles/replace',
    Component: lazy(() => import('pages/home')),
    exact: true,
    restricted: true,
  },
  {
    path: '/articles/partial-translate',
    Component: lazy(() => import('./components/swifteq/HcManager/Articles/subcomponents/TranslateArticles/PartialTranslate')),
    exact: true,
    restricted: true,
  },
  {
    path: '/links/:link_url?',
    Component: lazy(() => import('pages/home')),
    exact: false,
    restricted: true,
  },
  {
    path: '/dynamic-content',
    Component: lazy(() => import('pages/home')),
    exact: false,
    restricted: true,
  },
  {
    path: '/analytics',
    Component: lazy(() => import('pages/home')),
    exact: true,
    restricted: true,
  },
  {
    path: '/analytics/:id/details',
    Component: lazy(() => import('pages/home')),
    exact: true,
    restricted: true,
  },
  {
    path: '/analytics/:section/:someParam?',
    Component: lazy(() => import('pages/home')),
    exact: true,
    restricted: true,
  },
  {
    path: '/analytics/:section/:id/details/:params?',
    Component: lazy(() => import('pages/home')),
    exact: true,
    restricted: true,
  },
  {
    path: '/media/:link_url?',
    Component: lazy(() => import('pages/home')),
    exact: true,
    restricted: true,
  },
  // Init pages
  {
    path: '/init/connect',
    Component: lazy(() => import('pages/init/connect')),
    exact: true,
    restricted: true,
  },
  {
    path: '/init/processing',
    Component: lazy(() => import('pages/init/processing')),
    exact: true,
    restricted: true,
  },
  {
    path: '/init/expired',
    Component: lazy(() => import('pages/init/expired')),
    exact: true,
    restricted: true,
  },
  // Auth Pages
  {
    path: '/auth/register',
    Component: lazy(() => import('pages/auth/register')),
    exact: true,
    restricted: false,
  },
  {
    path: '/auth/login',
    Component: lazy(() => import('pages/auth/login')),
    exact: true,
    restricted: false,
  },
  {
    path: '/auth/easydoc',
    Component: lazy(() => import('pages/auth/easydoc')),
    exact: true,
    restricted: false,
  },
  {
    path: '/auth/hcmanager',
    Component: lazy(() => import('pages/auth/hcmanager')),
    exact: true,
    restricted: false,
  },
  {
    path: '/auth/analytics',
    Component: lazy(() => import('pages/auth/hcanalytics')),
    exact: true,
    restricted: false,
  },
  {
    path: '/auth/translate',
    Component: lazy(() => import('pages/auth/hctranslate')),
    exact: true,
    restricted: false,
  },
  {
    path: '/auth/mergedup',
    Component: lazy(() => import('pages/auth/mergedup')),
    exact: true,
    restricted: false,
  },
  {
    path: '/auth/removecc',
    Component: lazy(() => import('pages/auth/removecc')),
    exact: true,
    restricted: false,
  },
  {
    path: '/auth/attachments',
    Component: lazy(() => import('pages/auth/attachments')),
    exact: true,
    restricted: false,
  },
  {
    path: '/auth/404',
    Component: lazy(() => import('pages/auth/404')),
    exact: true,
    restricted: false,
  },
  {
    path: '/auth/500',
    Component: lazy(() => import('pages/auth/500')),
    exact: true,
    restricted: false,
  },
  //invite other users
  {
    path: '/invite-users',
    Component: lazy(() => import('pages/InviteUsers')),
    exact: true,
    restricted: false,
  },
  {
    path: '/payment',
    Component: lazy(() => import('pages/PaymentPage')),
    exact: true,
    restricted: false,
  },
  {
    path: '/glossary',
    Component: lazy(() => import('pages/glossary')),
    exact: true,
    restricted: true,
  },
]

const mapStateToProps = ({ settings }) => ({
  routerAnimation: settings.routerAnimation,
})

const Router = ({ history, routerAnimation }) => {
  return (
    <ConnectedRouter history={history}>
      <DataLayer>
        <Layout>
          <Route
            render={(state) => {
              const { location } = state
              return (
                <SwitchTransition>
                  <CSSTransition
                    key={location.pathname}
                    appear
                    classNames={routerAnimation}
                    timeout={routerAnimation === 'none' ? 0 : 300}
                  >
                    <Switch location={location}>
                      {routes.map(({ path, Component, exact, restricted }) => {
                        const AuthenticatedComponent = restricted
                          ? withAuthenticationRequired(Component)
                          : Component
                        return (
                          <Route
                            path={path}
                            key={path}
                            exact={exact}
                            render={() => {
                              return (
                                <div className={routerAnimation}>
                                  <Suspense fallback={null}>
                                    <AuthenticatedComponent />
                                  </Suspense>
                                </div>
                              )
                            }}
                          />
                        )
                      })}
                      <Redirect to="/auth/404" />
                    </Switch>
                  </CSSTransition>
                </SwitchTransition>
              )
            }}
          />
        </Layout>
      </DataLayer>
    </ConnectedRouter>
  )
}

export default connect(mapStateToProps)(Router)
